import HttpErrorResponseModel from "models/HttpErrorResponseModel";

export const SelectErrors = (response: HttpErrorResponseModel): string => {
  if (response.status === 400) {
    const errorsArray: any = Object.values(response.raw.data);
    response.message = errorsArray[0][0];
    return errorsArray[0][0];
  }
  return response.message;
};

export const SelectErrorsRawData = (response: HttpErrorResponseModel): any => {
  if (response.status === 400) {
    const errorsArray: any = Object.values(response.raw.data);
    return errorsArray[0];
  }
  return response.raw.data;
};
